import React from 'react';

const Badge = ({ one = {}, alumnuData, page, onClick, active }) => {

  // const grand = one.title ? one.title.search('Grand') !== -1 : false;
  const grand = one.grand;

  const BOT = 'https://a.storyblok.com/f/122726/720x720/c1b460bbc9/best-of-term-winner.png'

  const Title = ({ title = '' }) => {
    if (!title) return '';
    const year = title.split(' ')[0];
    const term = title.split(' ').slice(1).join(' ');
    return <>{year}<br />{term}</>
  }
  const title2 = `Best of Term Winner`;



  return <div className={`badge0 ${page ? 'badge0_page0' : ''}  ${grand ? 'badge0_page0_grand' : ''}`}
    onClick={onClick}
  >
    <div className={`badge0 ${page ? 'badge0_page _backzoom0' : ''} ${grand ? 'badge0_grand' : ''}`}

    >






      <div
        key={`badge_${one._id}_${alumnuData._id}`}
        className={`badge  ${grand ? 'badge_grand' : ''} ${page ? 'badge_page' : ''}`}
        // style={{ backgroundImage: `url(${one.thumbnail})` }} />
        style={{ backgroundImage: `url(${BOT})` }} />
      {page && <div className={`badge_page_title ${grand ? 'badge_page_title_grand' : ''}`}><Title title={one.title} /><br /><span className='badge_grand_title'>{title2}</span></div>}
      {page && one.category && <div className={`badge_category`}>{one.category}</div>}
    </div>
    {page && <div className="badge0_page_border" />}
  </div>

};

export default Badge;

